module.exports = __webpack_public_path__ + "static/media/novobanco_logo.bcd2ec3b.png";